import * as core from '../../../../../../../core'

import { query } from './phase-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'phase.bar.chart',
    description: 'Bar chart of change impacts by phase',
    name: 'Phase Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
